$(".variant_img").click(function () {
  var dataText = $(this).data("title");
  var dataKey = $(this).data("key");
  //var dataPreOrder = $(this).data("preorder");
  //alert("hello");

  $(this)
    .parents(".product-form__input")
    .find(".textvariant-sec")
    .text(dataText);

  var dataValue = $(this).data("value");
  //console.log("dataValue", dataValue);

  if (dataKey == "1") {
    if ($(window).width() < 767) {
      $(".product__media-item.grid__item.slider__slide").each(function (index) {
        var dataImgValue = $(this).data("value");
        if (dataImgValue == dataValue) {
          $(this).show();
        } else if (dataImgValue == "") {
          $(this).show();
        } else {
          $(this).hide();
        }
        console.log("dataImgValue", dataImgValue);
      });
    }

    $(".thumbnail-list__item.slider__slide").each(function (index) {
      var thumbImg = $(this).data("value");
      //console.log("thumbImg", index1);
      if (thumbImg == dataValue) {
        $(this).show();
      } else if (thumbImg == "") {
        $(this).show();
      } else {
        $(this).hide();
      }
    });
  }
 
});
 

function updateShippingAndButton() {

    // count options (from hidden select wrapper)
    var optionCount = $(".allvariant-section").data("option");

    // hide by default
    $(".shippingsection-main").hide();
    $(".product-form__submit").text("Add To Cart");

    // -------------------------
    // MULTI OPTION PRODUCT
    // -------------------------
    if (optionCount == "2") {

      var option1 = $(".optionname-sec1 input:checked + label").data("title");
      var option2 = $(".optionname-sec2 input:checked + label").data("title");

      if (!option1 || !option2) return;

      var combinedValue = option1 + " / " + option2;
      var showShipping = false;
      var dataContent = ''; // ✅ define outside
      var shippinghtml = `
        <p><b>Viral Fave : Ships in 7-10 days</b></p>
        <p>High demand item. Pre-order now to reserve your spot.</p>
      `;

      $(".allvariant-section select option").each(function () {

        if ($.trim($(this).text()) === combinedValue) {

          dataContent = $(this).data("content"); // ✅ now accessible
          if ($(this).data("preorder") == 1) {
            showShipping = true;
          }

          return false; // break loop
        }

      });

      if (showShipping) {
        $(".shippingsection-main").show();
        $(".product-form__submit").text("Pre Order");
        // debugger;
        // ✅ FINAL LOGIC
        if (dataContent && $.trim(dataContent) !== '') {
          $(".contentsection-shipping").html(dataContent);
        } else {
          $(".contentsection-shipping").html(shippinghtml);
        }
      }

    }

    // -------------------------
    // SINGLE OPTION PRODUCT
    // -------------------------
    else {
      //debugger;
      var dataPreOrder = $(".optionname-sec1 input:checked + label").data("preorder");
      var dataContent = $(".optionname-sec1 input:checked + label").data("content"); 
      var shippinghtml = $(`<p><b>Viral Fave : Ships in 7-10 days</b></p><p>High demand item. Pre-order now to reserve your spot.</p>`);
      //var dataText = $(this).data("title");
        if(dataPreOrder === 1){  
          console.log("dataContent", dataContent);
          $(".product-form__submit").text("Pre Order"); 
          $(".shippingsection-main").show(); 
          if(dataContent == ''){
            $(".contentsection-shipping").html(shippinghtml); 
          }else{
            $(".contentsection-shipping").html(dataContent); 
          }
          
        }else{ 
          $(".product-form__submit").text("Add To Cart"); 
          $(".shippingsection-main").hide(); 
        }

    }
}

/* 🔹 ONE event handler for both option groups */
$(document).on(
    "click",
    ".optionname-sec1 label, .optionname-sec2 label",
    function () {
        setTimeout(updateShippingAndButton, 0);
    }
);

 

// $(document).on("click", ".variant_img", function () {
//     var dataText = $(this).data("title");

//     var dataTextSecond = $(this)
//         .closest(".product-form__input--pill")
//         .find("input:checked + label")
//         .data("title");

//     console.log(dataTextSecond, "dataTextSecond");
//     console.log(dataText, "dataText");
// });


$(".fair_sec").click(function () {
  $(".fair_sec").removeClass("active");
  $(this).addClass("active");
  var dataText = $(this).data("text");

  $(".shadeContent-box").css("display", "none");
  $(`.shadeContent-box.${dataText}`).css("display", "flex");
});

$(".shadeContent-box").click(function () {
  $(".skinType-Section").removeClass("active");
  var dataId = $(this).data("id");
  $(`.section-${dataId}`).click();
});

$(".SelectSkin-Section button").click(function () {
  $(".skinType-Section").addClass("active");
  $("body").addClass("hidescroll");
});

$(".closebtn-sec span").click(function () {
  $(".skinType-Section").removeClass("active");
  $("body").removeClass("hidescroll");
});

$(".Howtouse-Section button").click(function () {
  $("#uspsection-main")[0].scrollIntoView({ bahavior: "smooth" });
});

// $(".offerSliderInner-Sec").slick({
//   dots: false,
//   infinite: false,
//   slidesToShow: 1,
//   slidesToScroll: 1,
//   prevArrow:
//     '<div class="arrowsec prev-arrowsec"><img src="https://cdn.shopify.com/s/files/1/0587/0531/3990/files/Vector_10_432392a6-cf0f-49f2-923d-990df479e22d.png?v=1730886836" /></div>',
//   nextArrow:
//     '<div class="arrowsec next-arrowsec"><img src="https://cdn.shopify.com/s/files/1/0587/0531/3990/files/Vector_9_c8c2e648-10d1-4608-8693-02636d69c7ec.png?v=1730886836" /></div>',
// });

$(".ShapeGuide-Sectioninner").slick({
  dots: false,
  infinite: false,
  slidesToShow: 5,
  slidesToScroll: 1,
  prevArrow:
    '<div class="arrowsec prev-arrowsec"><img src="https://cdn.shopify.com/s/files/1/0587/0531/3990/files/Vector_10_432392a6-cf0f-49f2-923d-990df479e22d.png?v=1730886836" /></div>',
  nextArrow:
    '<div class="arrowsec next-arrowsec"><img src="https://cdn.shopify.com/s/files/1/0587/0531/3990/files/Vector_9_c8c2e648-10d1-4608-8693-02636d69c7ec.png?v=1730886836" /></div>',
  responsive: [
    {
      breakpoint: 1024,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1,
      },
    },

    // You can unslick at a given breakpoint now by adding:
    // settings: "unslick"
    // instead of a settings object
  ],
});

$(".Slide-Ingredientinner").slick({
  dots: false,
  infinite: false,
  slidesToShow: 3,
  slidesToScroll: 1,
  prevArrow:
    '<div class="arrowsec prev-arrowsec"><img src="https://cdn.shopify.com/s/files/1/0587/0531/3990/files/Vector_10_432392a6-cf0f-49f2-923d-990df479e22d.png?v=1730886836" /></div>',
  nextArrow:
    '<div class="arrowsec next-arrowsec"><img src="https://cdn.shopify.com/s/files/1/0587/0531/3990/files/Vector_9_c8c2e648-10d1-4608-8693-02636d69c7ec.png?v=1730886836" /></div>',
  responsive: [
    {
      breakpoint: 1024,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1,
      },
    },

    // You can unslick at a given breakpoint now by adding:
    // settings: "unslick"
    // instead of a settings object
  ],
});

$(".product-usp-sectioninner").slick({
  dots: false,
  infinite: false,
  slidesToShow: 4,
  slidesToScroll: 1,
  autoplay: true,
  autoplaySpeed: 1500,
  prevArrow:
    '<div class="arrowsec prev-arrowsec"><img src="https://cdn.shopify.com/s/files/1/0587/0531/3990/files/Vector_9.png?v=1723212852"></div>',
  nextArrow:
    '<div class="arrowsec next-arrowsec"><img src="https://cdn.shopify.com/s/files/1/0587/0531/3990/files/Vector_10.png?v=1723212852"></div>',
  responsive: [
    {
      breakpoint: 1024,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1,
      },
    },

    // You can unslick at a given breakpoint now by adding:
    // settings: "unslick"
    // instead of a settings object
  ],
});

 
 setInterval(function(){ 
	// Minimum view count
	var minViews = 50;
	// Maximum view count
	var maxViews = 100;
	$viewCountElement = Math.floor(Math.random() * (maxViews - minViews) + minViews);   
  //console.log('$viewCountElement', $viewCountElement);
  document.getElementById("customerview").innerHTML = $viewCountElement; 
},4000); 